.title {
  margin-bottom: 1.2rem;
}

.description {
  margin-bottom: 2.2rem;
  word-break: break-word;
}
